import { createTheme, responsiveFontSizes } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface TypeBackground {
    primary: string;
    secondary: string;
    inactive: string;
    navigation: string;
    inverse: string;
    activity: string;
    attention: string;
    progress: string;
    brand: string;
  }
  interface Palette {
    custom: typeof Colors.lightColors;
  }
  interface PaletteOptions {
    custom?: typeof Colors.lightColors;
  }
}

export const graphColors = {
  c1: "rgba(79, 3, 170, 1)",
  c2: "rgba(89, 33, 242, 1)",
  c3: "rgba(150, 45, 255, 1)",
  c4: "rgba(128, 26, 255, 1)",
  c5: "rgba(183, 117, 255, 1)",
  c6: "rgba(125, 82, 96, 1)",
  c7: "rgba(153, 106, 120, 1)",
  c8: "rgba(128, 105, 191, 1)",
  c9: "rgba(154, 131, 219, 1)",
  c10: "rgba(126, 117, 255, 1)",
  c11: "rgba(182, 157, 247, 1)",
  c12: "rgba(207, 188, 255, 1)",
  c13: "rgba(255, 133, 168, 1)",
  c14: "rgba(239, 184, 200, 1)",
  c15: "rgba(246, 238, 255, 1)",
};

const Colors = {
  darkColors: {
    background: {
      primary: "rgba(0, 0, 0, 1)",
      secondary: "rgba(19, 19, 19, 1)",
      inactive: "rgba(52, 52, 52, 1)",
      navigation: "rgba(37, 37, 37, 1)",
      inverse: "rgba(178, 178, 178, 1)",
      activity: "rgba(39, 70, 244, 1)",
      attention: "rgba(222, 33, 33, 1)",
      progress: "rgba(0, 138, 2, 1)",
      brand: "rgba(89, 33, 242, 1)",
      warning: "rgba(230, 163, 18, 1)",
      activated: "rgba(0, 122, 2, 0.05)",
      deactivated: "rgba(174, 20, 20, 0.05)",
      pending: "rgba(230, 163, 18, 0.05)",
    },
    foreground: {
      primary: "rgba(255, 255, 255, 1)",
      secondary: "rgba(153, 153, 153, 1)",
      inactive: "rgba(89, 89, 89, 1)",
      inverted: "rgba(0, 0, 0, 1)",
      activity: "rgba(39, 70, 244, 1)",
      attention: "rgba(222, 33, 33, 1)",
      progress: "rgba(0, 138, 2, 1))",
      brand: "rgba(89, 33, 242, 1)",
      purple: "rgba(101, 85, 143, 1)",
    },
    border: {
      default: "rgba(89, 89, 89, 1)",
      subtle: "rgba(52, 52, 52, 1)",
      strong: "rgba(255, 255, 255, 1)",
      inactive: "rgba(52, 52, 52, 1)",
      activity: "rgba(39, 70, 244, 1)",
      attention: "rgba(222, 33, 33, 1)",
      progress: "rgba(0, 138, 2, 1)",
      brand: "rgba(89, 33, 242, 1)",
    },
  },
  lightColors: {
    background: {
      primary: "rgba(255, 255, 255, 1)",
      secondary: "rgba(243, 243, 243, 1)",
      inactive: "rgba(238, 238, 238, 1)",
      navigation: "rgba(247, 247, 247, 1)",
      inverse: "rgba(37, 37, 37, 1)",
      activity: "rgba(33, 63, 232, 1)",
      attention: "rgba(224, 0, 0, 1)",
      progress: "rgba(0, 122, 2, 1)",
      brand: "rgba(89, 33, 242, 1)",
      warning: "rgba(230, 163, 18, 1)",
      activated: "rgba(0, 122, 2, 0.05)",
      deactivated: "rgba(174, 20, 20, 0.05)",
      pending: "rgba(230, 163, 18, 0.05)",
    },
    foreground: {
      primary: "rgba(0, 0, 0, 1)",
      secondary: "rgba(89, 89, 89, 1)",
      inactive: "rgba(178, 178, 178, 1)",
      inverted: "rgba(255, 255, 255, 1)",
      activity: "rgba(33, 63, 232, 1)",
      attention: "rgba(224, 0, 0, 1)",
      progress: "rgba(0, 122, 2, 1)",
      brand: "rgba(96, 64, 135, 1)",
      purple: "rgba(101, 85, 143, 1)",
    },
    border: {
      default: "rgba(153, 153, 153, 1)",
      subtle: "rgba(238, 238, 238, 1)",
      strong: "rgba(0, 0, 0, 1)",
      inactive: "rgba(178, 178, 178, 1)",
      activity: "rgba(33, 63, 232, 1)",
      attention: "rgba(224, 0, 0, 1)",
      progress: "rgba(0, 122, 2, 1)",
      brand: "rgba(89, 33, 242, 1)",
    },
  },
};

export const theme = responsiveFontSizes(
  createTheme({
    typography: {
      fontFamily: ["Inter"].join(","),
    },
    palette: {
      custom: Colors?.lightColors,
    },
    colorSchemes: {
      light: {
        palette: {
          custom: Colors?.lightColors,
        },
      },
      dark: {
        palette: {
          custom: Colors?.darkColors,
        },
      },
    },
  })
);
